import { Translate } from '@travel/translation';

import styles from './providerReview.module.scss';

export const HEADER_LABEL = {
  badges: {
    sustainableBadge: <Translate id="Review_Common_Header.Sustainable_Badge" />,
    hometownTaxBadge: <Translate id="Review_Common_Header.Hometowntax_Badge" />,
  },
  tabs: {
    providerInfo: <Translate id="Review_Common_Header.Provider_Info" />,
    yadoNews: <Translate id="Review_Common_Header.Yado_News" />,
    planListLong: <Translate id="Review_Common_Header.Plan_Lng" />,
    planListShort: <Translate id="Review_Common_Header.Plan_Srt" />,
    roomListLong: <Translate id="Review_Common_Header.Room_Lng" />,
    roomListShort: <Translate id="Review_Common_Header.Room_Srt" />,
    galleryLong: <Translate id="Review_Common_Header.Gallery_Lng" />,
    galleryShort: <Translate id="Review_Common_Header.Gallery_Srt" />,
    map: <Translate id="Review_Common_Header.Map" />,
    reviewLong: <Translate id="Review_Common_Header.Review_Lng" />,
    reviewShort: <Translate id="Review_Common_Header.Review_Srt" />,
    couponLong: <Translate id="Review_Common_Header.Coupon_Lng" />,
    couponShort: <Translate id="Review_Common_Header.Coupon_Srt" />,
  },
  newsLetter: {
    title: <Translate id="Review_Common_Header.Newsletter" />,
    subscribe: <Translate id="Review_Common_Header.Register" />,
    subscribed: <Translate id="Review_Common_Header.Registering" />,
  },
  favorite: {
    title: <Translate id="Review_Common_Header.Favorite.Favorite_Button" />,
    add: <Translate id="Review_Common_Header.Favorite.Favorite_Button_Add" />,
    added: <Translate id="Review_Common_Header.Favorite.Favorite_Button_Added" />,
    toast: {
      addFavorite: <Translate id="Review_Common_Header.Favorite.Add_Favorite" />,
      deleteFavorite: <Translate id="Review_Common_Header.Favorite.Delete_Favorite" />,
      reachedLimit: <Translate id="Review_Common_Header.Favorite.Reach_Limit" />,
      error: <Translate id="Review_Common_Header.Favorite.Error" />,
      seeList: <Translate id="Review_Common_Header.Favorite.See_List" />,
      undo: <Translate id="Review_Common_Header.Favorite.Undo" />,
    },
  },
  sustainableLink: <Translate id="Review_Common_Header.Sustainable_Link" />,
  reviewCount: <Translate id="Review_Common.ReviewCount" />,
  national: <Translate id="Review_Common_Header.Rakuten_Travel_Top" />,
  bonusTooltip: {
    start: (
      <Translate
        id="Review_Common_Header.Bonus_Description1"
        data={{
          bold_text: (
            <Translate
              id="Review_Common_Header.Bonus_Description1_Bold"
              className={styles.bonusProgramPopupStrong}
            />
          ),
        }}
      />
    ),
    end: <Translate id="Review_Common_Header.Bonus_Description2" />,
  },
  breadcrumbs: {
    REVIEW: <Translate id="Review_SEO.Provider_Review_List.Breadcrumbs.Provider_Review" />,
  },
} as const;
